module.exports = __webpack_public_path__ + "img/site.a817c11c.png";